import React from 'react';
import { Button } from 'antd';

export const ButtonWrapper = props => {
    return <Button {...props} />;
};
